import { render, staticRenderFns } from "./Blocks.vue?vue&type=template&id=6340d7da"
import script from "./Blocks.vue?vue&type=script&lang=js"
export * from "./Blocks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports